/* eslint-disable no-unused-vars */

import p5, { Vector } from 'p5';

const randomInt = (min, max) => min + Math.round((max - min) * Math.random());

const noise = p5.prototype.noise;

const continuousNoise = (() => {
  let val = 0;
  return () => noise(val += 1);
})();

const noiseInt = (min, max) => min + Math.round((max - min) * continuousNoise());

// const vectorNoise = (() => {
//   const v = new Vector(
//     randomInt(-1, 1),
//     0
//   );
//   return () => {
//     new Vector()
//   };
// })();

const pointsPerLine = 10;

export default class {
  constructor(height, priorLine) {
    // const pointsPerLine = Math.round(height / 5);
    this.points = priorLine ?
      priorLine.points.map((point, idx) => ({
        x: point.x + 5 + (noise(point.x * idx, point.y * idx) * 2), // randomInt(2, 6), // noise(point.x, point.y),
        y: point.y,
      })) :
      [...new Array(pointsPerLine)].map((undef, idx) => ({
        x: 0,
        y: Math.round(idx * (height / pointsPerLine)),
      })).concat({ x: 0, y: height });
    this.minX = this.points.reduce((min, point) => Math.min(min, point.x), Infinity);
    window.line = this;
    this.visible = 0;
  }

  draw(p) {
    this.visible += 1;
    p.line(
      Math.round(this.points[this.visible - 1].x),
      this.points[this.visible - 1].y,
      Math.round(this.points[this.visible].x),
      this.points[this.visible].y
    );
    // Drawing will be complete when we run out of points
    return ! this.points[this.visible + 1];
  }

  drawAll(p) {
    for (let i = 1; i < this.points.length; i += 1) {
      p.line(
        this.points[i - 1].x,
        this.points[i - 1].y,
        this.points[i].x,
        this.points[i].y
      );
    }
    return true;
  }

  drawAllCurve(p) {
    p.beginShape();
    // Duplicate first point to create first control point
    const firstPoint = this.points[0];
    p.curveVertex(firstPoint.x, firstPoint.y);
    // Add each point to curve
    this.points.forEach(point => p.curveVertex(Math.round(point.x), point.y));
    // Duplicate last point to create last control point
    const lastPoint = this.points[this.points.length - 1];
    p.curveVertex(lastPoint.x, lastPoint.y);
    p.endShape();
    return true;
  }
}



// WEBPACK FOOTER //
// ./components/Lines/Line.js